// extracted by mini-css-extract-plugin
module.exports = {"rightHeaderWrapper":"DFw34sfh","negative":"Off5p4bn","rightHeaderReturnLabel":"ZfS8N29e","rightHeaderReturnValue":"M7G6Qr2q"};